<template>
  <!-- <div class="box">
    {{ resurs.tekst }} for {{ resurs.tip }}
    <router-link
      :to="{ name: 'ResursForm', params: { resurs: resurs } }"
      v-show="izmenaDozvoljena"
      >Izmeni</router-link
    >
  </div> -->

  <section class="media">
    <div class="media-left" v-if="slikaVidljiva">
      <figure class="image is-96x96">
        <img
          :src="thumbUrl"
          alt="Слика"
          v-if="postojiSlika"
          class="image is-96x96"
        />
        <img src="@/assets/images/trasparent48px.png" alt="Слика" v-else />
      </figure>
    </div>
    <!-- prikaz resursa -->
    <div class="media-content">
      <p>
        <span class="is-italic" v-show="datumVidljiv"
          >{{ localDate }} <br
        /></span>

        <span class="has-text-weight-semibold" v-show="naslovVidljiv"
          >{{ resurs.naslov }} <br
        /></span>

        <!-- displaying linebreaks with CSS -->
        <span class="line-breaks" v-show="tekstVidljiv">{{
          resurs.tekst
        }}</span>
        &nbsp;
        <!-- <a
          v-show="dokumentVidljiv && resurs.naziv_dokumenta"
          target="_blank"
          :href="documentUrl"
          class="subtitle"
          ><i class="fas fa-paperclip"></i
        ></a> -->
        <a
          v-show="dokumentVidljiv"
          v-for="d in dokumenti"
          :href="documentUrl(d.id)"
          target="_blank"
          class="subtitle"
          :key="d.id"
          ><i class="fas fa-paperclip"></i
        ></a>
        &nbsp;
        <router-link
          class="is-pulled-right"
          :to="{
            name: 'ResursDetalji',
            params: { id: resurs.id, tip: resurs.tip }
          }"
          v-show="linkDetaljiVidljiv"
          ><i class="fas fa-arrow-circle-right has-text-info fa-lg"></i
        ></router-link>
      </p>
    </div>
    <!-- izmena -->
    <div class="media-right" v-show="loggedIn">
      <router-link
        :to="{
          name: 'ResursForma',
          params: { id: resurs.id, tip: resurs.tip }
        }"
        v-show="izmenaDozvoljena"
        ><i class="far fa-edit"></i
      ></router-link>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/conf'

export default {
  props: {
    resurs: {
      type: Object,
      required: true
    },
    izmenaDozvoljena: {
      type: Boolean,
      default: false
    },
    datumVidljiv: {
      type: Boolean,
      default: true
    },
    naslovVidljiv: {
      type: Boolean,
      default: true
    },
    tekstVidljiv: {
      type: Boolean,
      default: true
    },
    slikaVidljiva: {
      type: Boolean,
      default: true
    },
    dokumentVidljiv: {
      type: Boolean,
      default: false
    },
    linkDetaljiVidljiv: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    slikaUrl(id) {
      return baseUrl + '/slika/' + id
    },
    documentUrl(id) {
      return baseUrl + '/dokument/' + id
    },
    linkUrl(url) {
      if (url.startsWith('http:')) {
        return url
      } else {
        return 'http://' + url
      }
    }
  },
  computed: {
    postojiSlika() {
      // if (this.resurs.tip === 'vest') {
      //   return true
      // } else if (this.resurs.tip === 'javna-nabavka') {
      //   return true
      // } else if (this.resurs.tip === 'cenovnik') {
      //   return false
      // } else if (this.resurs.tip === 'cenovnik') {
      //   return false
      // } else if (this.resurs.tip === 'program') {
      //   return false
      // } else if (this.resurs.tip === 'izvestaj') {
      //   return false
      // } else if (this.resurs.tip === 'organizacija') {
      //   return false
      // } else {
      //   return false
      // }
      return this.slike.length > 0
    },
    slike() {
      return this.resurs.elementi.filter(e => {
        return e.tip === 'slika'
      })
    },
    dokumenti() {
      return this.resurs.elementi.filter(e => {
        return e.tip === 'dokument'
      })
    },
    linkovi() {
      return this.resurs.elementi.filter(e => {
        return e.tip === 'link'
      })
    },
    // slikaUrl() {
    //   // produkcija
    //   //return this.resurs.naziv_slike ? '/slika/' + this.resurs.id : null
    //   // development
    //   return this.resurs.naziv_slike
    //     ? baseUrl + '/slika/' + this.resurs.id
    //     : null
    // },
    thumbUrl() {
      // produkcija
      //return this.resurs.naziv_slike ? '/slika/' + this.resurs.id : null
      // development
      return this.postojiSlika ? baseUrl + '/thumb/' + this.resurs.id : null
    },
    // documentUrl() {
    //   // produkcija
    //   //return this.resurs.naziv_dokumenta ? '/dokument/' + this.resurs.id : null
    //   // development
    //   return this.resurs.naziv_dokumenta
    //     ? baseUrl + '/dokument/' + this.resurs.id
    //     : null
    // },

    detaljiUrl() {
      // produkcija
      //return this.resurs.naziv_dokumenta ? '/dokument/' + this.resurs.id : null
      // development
      return this.resurs.naziv_dokumenta
        ? baseUrl + '/resurs/' + this.resurs.id
        : null
    },
    localDate() {
      if (!this.resurs.datum) {
        return null
      }
      // 2020-09-11
      let parts = this.resurs.datum.split(/-/)
      return parts[2] + '.' + parts[1] + '.' + parts[0]
    },
    localDateTime(vreme) {
      //return 'dokument/' + this.resurs.id
      // 2020-09-11 22:33:44
      let parts = vreme.split(/-| |:/)
      return (
        parts[2] +
        '.' +
        parts[1] +
        '.' +
        parts[0] +
        ' ' +
        parts[3] +
        ':' +
        parts[4]
      )
    },
    ...mapState('auth', ['loggedIn', 'userData'])
  }
}
</script>

<style>
.image-box {
  height: 96px;
}

.line-breaks {
  white-space: pre-line;
}
</style>
